import { render } from "./ProductOutboxQueueList.vue?vue&type=template&id=3052755f"
import script from "./ProductOutboxQueueList.vue?vue&type=script&lang=js"
export * from "./ProductOutboxQueueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__